import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import { CountriesActions } from 'applicaiton/constants/actions';

import { CountriesAPI } from 'integration/api/countries';

/**
 * Async thunk action creator that fetches supported countries from an API.
 * @returns {Promise} A promise that resolves with the data returned by the API.
 */
export const getSupportedCountries = createAsyncThunk(
  CountriesActions.getSupportedCountries,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await CountriesAPI.getSupportedCountries();
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
